import{jsx as t}from"react/jsx-runtime";import{Picker as o}from"emoji-mart";import r from"styled-components";const e=r.div`
	height: calc(100% - 44px);

	.emoji-mart {
		display: flex;
		flex-direction: column;
		position: absolute;
		inset: 0;
		background: ${({theme:t})=>t.bg.general};
		border: none;
		border-radius: 3px !important;
		width: 100% !important;
		height: 100% !important;
		font-family: -apple-system, BlinkMacSystemFont, sans-serif !important;

		.emoji-mart-bar {
			order: 2;

			.emoji-mart-anchors {
				padding: 0;
			}

			&:last-child {
				display: none;
			}

			&:first-child {
				border-bottom-width: 0 !important;
			}
		}

		.emoji-mart-search {
			padding: 0;
			margin: 0;
			order: 1;

			input {
				margin: 0;
				font-size: 14px !important;
				height: 40px;
				color: ${({theme:t})=>t.text.text};
				background: ${({theme:t})=>t.bg.primary};
				border: none;
				border-radius: 3px !important;
			}

			.emoji-mart-search-icon {
				&:disabled svg {
					width: 18px;
					height: 18px;
				}

				svg {
					fill: ${({theme:t})=>t.text.text};
					opacity: 1;
					margin: 3px -8px 0 0;
				}
			}
		}

		.emoji-mart-anchor-icon {
			cursor: pointer !important;
		}
		.emoji-mart-category-label {
			margin-top: 10px;
			font-size: 14px !important;
			color: ${({theme:t})=>t.text.text};
			top: -1px;

			span {
				width: 100%;
				background: ${({theme:t})=>t.bg.general};
				cursor: default;
			}
		}

		.emoji-mart-anchor-bar {
			background-color: ${({theme:t})=>t.text.text} !important;
		}

		.emoji-mart-scroll {
			position: absolute;
			width: 265px;
			top: 100px;
			bottom: 0;
			height: auto;
			padding: 0 0 6px 0;
			margin: 0 -5px;

			button.emoji-mart-emoji {
				padding: 4px;

				span {
					cursor: pointer !important;
				}
			}

			&::-webkit-scrollbar {
				width: 5px;
			}
			&::-webkit-scrollbar-track {
				background: transparent;
			}
			&::-webkit-scrollbar-thumb {
				background: #d4d4d4;
				border-radius: 4px;

				&::hover {
					background: #999;
				}
			}
		}

		.emoji-mart-anchor-selected {
			padding: 12px 4px 12px;
			color: ${({theme:t})=>t.text.text} !important;

			.emoji-mart-anchor-bar {
				bottom: 6px;
			}
		}
	}
`,i=({handleClickOnEmoji:r,customStyles:i})=>t(e,{children:t(o,{onSelect:t=>r(t),showPreview:!1,emojiTooltip:!0,style:Object.assign({},i)})});export{i as EmojiPicker};
